import angular from 'angular';
/* Config Imports */
import HelpRouteConfig from './help.route';
/* Controller Imports */
import HelpController from './help.controller';
import sortObject from './filters/sortObject.filter';
import HelpTranslationService from './translations/help-translation.service';
import HelpTranslation from './translations/help-translate.directive';

const helpModule = angular
  .module('app.help', [
    //THIRD PARTY
    'ui.router',
    'ui.bootstrap',
    'ui.router',
    'ncy-angular-breadcrumb',
    'gettext'
  ])
  /* Filters */
  .filter('sortObject', sortObject)
  /* Configurations */
  .config(HelpRouteConfig)
  .service('helpTranslationService', HelpTranslationService)
  .directive('helpTranslate', HelpTranslation)
  /* Controllers */
  .controller('HelpController', HelpController);

export default helpModule.name;
